export enum RestrictionsType {
  Operational = 'OPERATIONAL',
  General = 'GENERAL',
  HealthSafety = 'HEALTH_AND_SAFETY',
};
